// fetch forex deposits
export const FETCH_INTERNAL_TRANSFERS_REQUESTED = "FETCH_INTERNAL_TRANSFERS_REQUESTED";
export const FETCH_INTERNAL_TRANSFERS_SUCCESS = "FETCH_INTERNAL_TRANSFERS_SUCCESS";
export const FETCH_INTERNAL_TRANSFERS_FAIL = "FETCH_INTERNAL_TRANSFERS_FAIL";

export const ADD_INTERNAL_TRANSFER_REQUESTED = "ADD_INTERNAL_TRANSFER_REQUESTED";
export const ADD_INTERNAL_TRANSFER_SUCCESS = "ADD_INTERNAL_TRANSFER_SUCCESS";
export const ADD_INTERNAL_TRANSFER_FAIL = "ADD_INTERNAL_TRANSFER_FAIL";
export const ADD_INTERNAL_TRANSFER_CLEAR = "ADD_INTERNAL_TRANSFER_CLEAR";
export const ADD_INTERNAL_TRANSFER_ERROR_CLEAR = "ADD_INTERNAL_TRANSFER_ERROR_CLEAR";


export const APPROVE_INTERNAL_TRANSFER = "APPROVE_INTERNAL_TRANSFER";
export const APPROVE_INTERNAL_TRANSFER_SUCCESS = "APPROVE_INTERNAL_TRANSFER_SUCCESS";
export const REJECT_INTERNAL_TRANSFER = "REJECT_INTERNAL_TRANSFER";
export const REJECT_INTERNAL_TRANSFER_SUCCESS = "REJECT_INTERNAL_TRANSFER_SUCCESS";

export const INTERNAL_TRANSFER_AUTOMATION = "INTERNAL_TRANSFER_AUTOMATION";
export const INTERNAL_TRANSFER_AUTOMATION_SUCCESS = "INTERNAL_TRANSFER_AUTOMATION_SUCCESS";

export const GET_INTERNAL_TRANSFER_AUTOMATION_INIT = "GET_INTERNAL_TRANSFER_AUTOMATION_INIT";
export const GET_INTERNAL_TRANSFER_AUTOMATION_SUCCESS = "GET_INTERNAL_TRANSFER_AUTOMATION_SUCCESS";